import { render } from "./CustomTopicModelEditorDetails.vue?vue&type=template&id=52d36028"
import script from "./CustomTopicModelEditorDetails.vue?vue&type=script&lang=js"
export * from "./CustomTopicModelEditorDetails.vue?vue&type=script&lang=js"

import "./CustomTopicModelEditorDetails.vue?vue&type=style&index=0&id=52d36028&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__